module.exports = __webpack_public_path__ + "img/you-are-here.6521d122.png";